import { type FC } from 'react';
import { OpenQuote } from '../icons/OpenQuote';
import { ViewOnce } from '../view-once';
import './testimonial-card.scss';

export type TestimonialCardProps = {
  testimonial: string;
  bylineImage: string;
  bylineName: string;
  bylineLocation?: string;
  onView?: () => void;
};

export const TestimonialCard: FC<TestimonialCardProps> = ({
  testimonial,
  bylineImage,
  bylineName,
  bylineLocation,
  onView,
}) => (
  <ViewOnce onView={onView}>
    <div className="testimonial-card" data-testid="testimonial-card">
      <div className="testimonial-card__content">
        <OpenQuote />
        <p className="testimonial-card__text" data-testid="testimonial-text">
          {testimonial}
        </p>
      </div>
      <hr
        className="testimonial-card__divider"
        data-testid="testimonial-divider"
      />
      <div className="testimonial-card__byline">
        <img
          src={bylineImage}
          alt={bylineName}
          className="testimonial-card__avatar"
          data-testid="testimonial-avatar"
        />
        <div className="testimonial-card__byline-info">
          <p
            className="testimonial-card__byline-name"
            data-testid="byline-name"
          >
            {bylineName}
          </p>
          {bylineLocation && (
            <p
              className="testimonial-card__byline-location"
              data-testid="byline-location"
            >
              {bylineLocation}
            </p>
          )}
        </div>
      </div>
    </div>
  </ViewOnce>
);

export default TestimonialCard;
